import PageLayout from "@/components/PageLayout";
import { STUDIO } from "@/lib/site";

export default function CookiePolicyPage() {
  return (
    <PageLayout>
      <div data-testid="cookie-policy-page" className="pt-28 pb-20 bg-[#F6F8F3]">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <span className="eyebrow">Informativa</span>
          <h1 className="font-serif-elegant mt-6 text-4xl lg:text-5xl font-light text-[#3D3B3A] leading-tight">
            Cookie Policy
          </h1>
          <p className="mt-4 text-sm text-[#73706E]">
            Ai sensi del Provvedimento del Garante per la protezione dei dati personali
            del 10 giugno 2021 e successive linee guida. Ultimo aggiornamento: 18 giugno 2026.
          </p>

          <div className="mt-12 space-y-10 text-[#3D3B3A] leading-[1.85]">
            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">Cosa sono i cookie</h2>
              <p className="text-[#73706E]">
                I cookie sono piccoli file di testo che i siti web memorizzano sul dispositivo
                dell&apos;utente per riconoscerlo nelle visite successive o per analizzarne il comportamento.
                Possono essere installati direttamente dal sito visitato (cookie di prima parte)
                o da soggetti terzi (cookie di terze parti).
              </p>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">Cookie utilizzati da questo sito</h2>
              <p className="text-[#73706E] mb-5">
                Questo sito utilizza esclusivamente <strong>cookie tecnici necessari</strong> per
                il corretto funzionamento, per i quali, ai sensi della normativa vigente, <strong>non
                è richiesto il consenso preventivo</strong> dell&apos;utente.
              </p>

              <div className="border border-[#CFD9C5] rounded-2xl overflow-hidden">
                <table className="w-full text-sm">
                  <thead className="bg-[#E9EFE4] text-[#3D3B3A]">
                    <tr>
                      <th className="text-left p-4">Nome</th>
                      <th className="text-left p-4">Finalità</th>
                      <th className="text-left p-4">Durata</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-t border-[#CFD9C5]">
                      <td className="p-4 font-mono text-xs">chiara_cookie_consent</td>
                      <td className="p-4 text-[#73706E]">Memorizza la preferenza dell&apos;utente sui cookie</td>
                      <td className="p-4 text-[#73706E]">12 mesi</td>
                    </tr>
                    <tr className="border-t border-[#CFD9C5]">
                      <td className="p-4 font-mono text-xs">chiara_admin_token</td>
                      <td className="p-4 text-[#73706E]">Permette l&apos;accesso alla sola area riservata della professionista</td>
                      <td className="p-4 text-[#73706E]">Sessione</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">Cookie di profilazione e di terze parti</h2>
              <p className="text-[#73706E]">
                Questo sito <strong>non utilizza</strong> cookie di profilazione, marketing,
                pubblicità o analisi statistica di terze parti. Non sono presenti pixel di
                tracciamento di social network né strumenti analitici quali Google Analytics.
              </p>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">Come gestire le preferenze</h2>
              <p className="text-[#73706E]">
                L&apos;utente può in qualsiasi momento modificare le proprie preferenze sui cookie
                attraverso le impostazioni del browser, accettando, bloccando o rimuovendo i cookie
                già installati. Si segnala che la disabilitazione dei cookie tecnici può comportare
                limitazioni nella fruizione del sito.
              </p>
              <p className="text-[#73706E] mt-3">
                Per la disabilitazione consulta la documentazione del tuo browser:
              </p>
              <ul className="mt-3 ml-6 list-disc text-[#73706E] space-y-1">
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer" className="text-[#7E9C7B] underline">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noreferrer" className="text-[#7E9C7B] underline">Mozilla Firefox</a></li>
                <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer" className="text-[#7E9C7B] underline">Apple Safari</a></li>
                <li><a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noreferrer" className="text-[#7E9C7B] underline">Microsoft Edge</a></li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif-elegant text-2xl lg:text-3xl mb-3">Titolare e contatti</h2>
              <p className="text-[#73706E]">
                Titolare del trattamento è la <strong>{STUDIO.name}</strong>, {STUDIO.address}, {STUDIO.city}.
                Per qualsiasi richiesta scrivi a{" "}
                <a href={`mailto:${STUDIO.email}`} className="text-[#7E9C7B] underline">{STUDIO.email}</a>.
              </p>
              <p className="text-[#73706E] mt-3 text-sm">
                Per maggiori informazioni sul trattamento dei dati personali consulta la nostra{" "}
                <a href="/privacy" className="text-[#7E9C7B] underline">Privacy Policy</a>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
